export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'es', 'it'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'en';
export const LANGUAGE_STORAGE_KEY = 'ablecomply_locale';

const LOCALE_ALIASES: Record<string, AppLocale> = {
  en: 'en',
  'en-us': 'en',
  'en-gb': 'en',
  de: 'de',
  'de-de': 'de',
  fr: 'fr',
  'fr-fr': 'fr',
  es: 'es',
  'es-es': 'es',
  'es-mx': 'es',
  it: 'it',
  'it-it': 'it',
};

export function isSupportedLocale(value: string): value is AppLocale {
  return SUPPORTED_LOCALES.includes(value as AppLocale);
}

export function detectLocale(value: string | null | undefined): AppLocale | null {
  if (!value) return null;

  const normalized = value.trim().toLowerCase().replace('_', '-');
  return LOCALE_ALIASES[normalized] ?? LOCALE_ALIASES[normalized.split('-')[0] ?? ''] ?? null;
}

export function normalizeLocale(value: string | null | undefined): AppLocale {
  return detectLocale(value) ?? DEFAULT_LOCALE;
}

export function resolvePreferredLocale(input: {
  savedLocale?: string | null;
  browserLanguages?: ReadonlyArray<string | null | undefined>;
  fallbackLocale?: AppLocale;
}): AppLocale {
  const saved = detectLocale(input.savedLocale);
  if (saved) {
    return saved;
  }

  for (const candidate of input.browserLanguages ?? []) {
    const detected = detectLocale(candidate);
    if (detected) {
      return detected;
    }
  }

  return input.fallbackLocale ?? DEFAULT_LOCALE;
}
